import { Card, CardContent, styled, Typography } from '@ethings/ui-toolkit';
// eslint-disable-next-line camelcase
import { SxProps, unstable_styleFunctionSx as unstableStyleFunctionSx } from '@mui/system';
import { FC, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useResponsiveText } from '../../hooks';
import { innerText } from '../../util';
import { NoPermissionsCardBody } from '../permissions';

interface Props {
  sx?: SxProps;
}

const StyledCardContent = styled(CardContent)({
  padding: 0,
});

const SxWrapper = styled('div')<Props>(({ sx, theme }) => ({
  ...(unstableStyleFunctionSx({ sx, theme } as never) as Record<string, unknown>),
}));

export const NoPermission: FC<Props> = ({ sx }): JSX.Element => {
  const { t } = useTranslation(['common']);
  const titleText = t('common:features.media');
  const h5Styles = useResponsiveText('1.5rem', innerText(titleText).length, {
    minFontSize: '1.25rem',
    maxFontSize: '1.5rem',
    textLengthThreshold: 25,
  });

  return (
    <SxWrapper sx={sx}>
      <Card>
        <StyledCardContent>
          <Typography
            variant="h5"
            style={{
              fontSize: h5Styles.fontSize,
              lineHeight: h5Styles.lineHeight,
              wordBreak: h5Styles.wordBreak,
              whiteSpace: h5Styles.whiteSpace,
              overflow: h5Styles.overflow,
              textOverflow: h5Styles.textOverflow,
            }}
          >
            {titleText}
          </Typography>
        </StyledCardContent>
        <NoPermissionsCardBody data-testid='no-permissions-media' />
      </Card>
    </SxWrapper>
  );
};
